(function () {
  'use strict';
  let busy = false;
  const parse = value => { try { return JSON.parse(value); } catch (_) { return null; } };
  function resolve(card) {
    if (!card) return {error: 'Choose an offer.'};
    const product = parse(card.dataset.nrsmProduct);
    if (!product || !Array.isArray(product.variants)) return {error: 'This offer needs its Shopify product configured.'};
    const id = card.dataset.nrsmVariantId.trim();
    const variant = id ? product.variants.find(v => String(v.id) === id) : product.variants.length === 1 ? product.variants[0] : null;
    if (!variant) return {error: 'Configure the exact variant for this offer.'};
    if (!variant.available) return {error: 'This offer is sold out.'};
    const quantity = Number(card.dataset.nrsmQuantity);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10) return {error: 'Configure a valid cart quantity.'};
    const rawPlan = card.dataset.nrsmSellingPlan.trim();
    const plan = rawPlan ? variant.sellingPlans.find(p => String(p.id) === rawPlan) : null;
    if (rawPlan && !plan) return {error: 'The selling plan does not belong to this variant.'};
    if ((card.dataset.nrsmRequireSubscription === 'true' || variant.requiresSellingPlan) && !plan) return {error: 'Configure the subscription plan before enabling this offer.'};
    return {variant, quantity, plan, price: (plan ? plan.price : variant.price) * quantity};
  }
  function money(cents) {
    const code = document.documentElement.dataset.nrsmCurrency || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency:code}).format(cents / 100);
  }
  function update() {
    const cards = [...document.querySelectorAll('[data-nrsm-offer]')];
    cards.forEach(card => {
      const result = resolve(card);
      card.setAttribute('aria-pressed', String(card.classList.contains('sel')));
      const price = card.querySelector('.qs-price');
      if (!result.error && price) {
        const divisor = Math.max(1, Number(card.dataset.nrsmServings) || 1);
        price.replaceChildren(document.createTextNode(money(result.price / divisor) + ' '));
        const caption = document.createElement('small'); caption.textContent = card.dataset.nrsmCaption || ''; price.appendChild(caption);
      } else if (price && card.dataset.nrsmShowSourcePrice !== 'true') price.textContent = 'Select product';
    });
    const result = resolve(cards.find(c => c.classList.contains('sel')));
    document.querySelectorAll('[data-nrsm-atc]').forEach(button => {
      button.disabled = busy || !!result.error;
      button.setAttribute('aria-busy', String(busy));
    });
    const message = document.querySelector('[data-nrsm-cart-message]');
    if (message) message.textContent = result.error ? (window.Shopify && window.Shopify.designMode ? result.error : 'This offer is not available yet.') : '';
  }
  document.addEventListener('click', async event => {
    const card = event.target.closest('[data-nrsm-offer]');
    if (card) {
      document.querySelectorAll('[data-nrsm-offer]').forEach(c => c.classList.toggle('sel', c === card));
      update(); return;
    }
    const button = event.target.closest('[data-nrsm-atc]');
    if (!button || busy) return;
    event.preventDefault();
    const result = resolve(document.querySelector('[data-nrsm-offer].sel'));
    if (result.error) { update(); return; }
    busy = true; update();
    const item = {id: result.variant.id, quantity: result.quantity};
    if (result.plan) item.selling_plan = result.plan.id;
    const root = (window.NRSMRoutes && window.NRSMRoutes.root) || '/';
    try {
      const response = await fetch(root.replace(/\/?$/, '/') + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[item]})
      });
      const responseData = await response.json();
      if (!response.ok) throw new Error(responseData.description || responseData.message || 'Could not add this offer. Please try again.');
      document.dispatchEvent(new CustomEvent('nrsm:cart-added', {detail:responseData}));
      window.location.assign(root.replace(/\/?$/, '/') + 'checkout');
    } catch (error) {
      busy = false; update();
      const message = document.querySelector('[data-nrsm-cart-message]');
      if (message) message.textContent = error.message;
    }
  });
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  // Exposed solely to make pre-install checks possible without an actual purchase.
  window.NRSMOffers = {resolve, update};
})();
